export const NumberFormat = props => {
    const { value } = props;

    return parseFloat(value)
        .toString();
};
